import React, { PureComponent } from 'react'
import { Table } from 'reactstrap'
import { Icon } from 'components'
import { range } from 'lodash'
import moment from 'moment'
import 'moment-duration-format'
import { Player } from '../Player/Player'

import './Ranking.css'

const icons = ['position', 'clock', 'credits', 'gearboxcircle', 'engine']

const renderTableHeader = season => (
    <th key={season} className="ST-Header-season">
        <Icon name={icons[season]} />
    </th>
)

const renderTableRow = (player, index) => {
    const { points, totalTime, credits, engineHealth, gearboxHealth, playerNickname, playerName } = player
    let time = isNaN(totalTime) ? 'OUT' : totalTime
    if (time !== 'OUT') {
        time = totalTime ? moment.duration(totalTime, 'minutes').format('mm:ss') : '--:--'
    }
    return (
        <tr key={`row-${index}`}>
            <td>
                <Player name={playerName} nickname={playerNickname} hideImage />
            </td>
            <td>
                <span className="value">{points >= 0 ? points : '--'}</span>
            </td>
            <td>
                <span className="value">{time}</span>
            </td>
            <td>
                <span className="value">{!isNaN(credits) && credits !== null ? parseFloat(credits).toFixed(2) : '--'}</span>
            </td>
            <td>
                <span className="value">{!isNaN(gearboxHealth) && gearboxHealth !== null ? parseFloat(gearboxHealth).toFixed(2) : '--'} %</span>
            </td>
            <td>
                <span className="value">{!isNaN(engineHealth) && engineHealth !== null ? parseFloat(engineHealth).toFixed(2) : '--'} %</span>
            </td>
        </tr>
    )
}

export function Ranking({ ranking, type }) {
    return (
        <div className={`McGame-Ranking McGame-Ranking--${type}`}>
            <Table>
                <thead>
                    <tr>
                        <th />
                        {range(5).map(renderTableHeader)}
                    </tr>
                </thead>
                <tbody>{ranking.map(renderTableRow)}</tbody>
            </Table>
        </div>
    )
}



// WEBPACK FOOTER //
// src/pages/MC/Game/Ranking/Ranking.js